// extracted by css-extract-rspack-plugin
export default {"item":"O8f6b","active":"uswWe","link":"WoIkJ"};